import React, { useState, useEffect } from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { renderFormField } from 'utils/forms'

const ClientTSPAllocation = ({
  intakeState,
  updateIntakeStateAndSubmit,
  updateIntakeStateAtKey,
}) => {
  const parsedTspAllocation =
    typeof intakeState.tspAllocation === 'string'
      ? JSON.parse(intakeState.tspAllocation)
      : intakeState.tspAllocation || {}
  const initialAllocation = {
    tspGFund: {
      label: 'G Fund',
      percentage: parsedTspAllocation.tspGFund ?? '',
      selected: parsedTspAllocation.tspGFund != '' ? true : false,
      color: '#495057',
    },
    tspFFund: {
      label: 'F Fund',
      percentage: parsedTspAllocation.tspFFund ?? '',
      selected: parsedTspAllocation.tspFFund != '' ? true : false,
      color: '#262627',
    },
    tspCFund: {
      label: 'C Fund',
      percentage: parsedTspAllocation.tspCFund ?? '',
      selected: parsedTspAllocation.tspCFund != '' ? true : false,

      color: '#ADC5E3',
    },
    tspSFund: {
      label: 'S Fund',
      percentage: parsedTspAllocation.tspSFund ?? '',
      selected: parsedTspAllocation.tspSFund != '' ? true : false,

      color: '#1F5493',
    },
    tspIFund: {
      label: 'I Fund',
      percentage: parsedTspAllocation.tspIFund ?? '',
      selected: parsedTspAllocation.tspIFund != '' ? true : false,

      color: '#21B8FD',
    },
    tspLIncome: {
      label: 'L Income',
      percentage: parsedTspAllocation.tspLIncome ?? '',
      selected: parsedTspAllocation.tspLIncome != '' ? true : false,

      color: '#344767',
    },
    tspL2025: {
      label: 'L 2025',
      percentage: parsedTspAllocation.tspL2025 ?? '',
      selected: parsedTspAllocation.tspL2025 != '' ? true : false,

      color: '#344767',
    },
    tspL2030: {
      label: 'L 2030',
      percentage: parsedTspAllocation.tspL2030 ?? '',
      selected: parsedTspAllocation.tspL2030 != '' ? true : false,

      color: '#344767',
    },
    tspL2035: {
      label: 'L 2035',
      percentage: parsedTspAllocation.tspL2035 ?? '',
      selected: parsedTspAllocation.tspL2035 != '' ? true : false,

      color: '#344767',
    },
    tspL2040: {
      label: 'L 2040',
      percentage: parsedTspAllocation.tspL2040 ?? '',
      selected: parsedTspAllocation.tspL2040 != '' ? true : false,

      color: '#344767',
    },
    tspL2045: {
      label: 'L 2045',
      percentage: parsedTspAllocation.tspL2045 ?? '',
      selected: parsedTspAllocation.tspL2045 != '' ? true : false,

      color: '#344767',
    },
    tspL2050: {
      label: 'L 2050',
      percentage: parsedTspAllocation.tspL2050 ?? '',
      selected: parsedTspAllocation.tspL2050 != '' ? true : false,

      color: '#344767',
    },
    tspL2055: {
      label: 'L 2055',
      percentage: parsedTspAllocation.tspL2055 ?? '',
      selected: parsedTspAllocation.tspL2055 != '' ? true : false,

      color: '#344767',
    },
    tspL2060: {
      label: 'L 2060',
      percentage: parsedTspAllocation.tspL2060 ?? '',
      selected: parsedTspAllocation.tspL2060 != '' ? true : false,

      color: '#344767',
    },
    tspL2065: {
      label: 'L 2065',
      percentage: parsedTspAllocation.tspL2065 ?? '',
      selected: parsedTspAllocation.tspL2065 != '' ? true : false,

      color: '#344767',
    },
    tspL2070: {
      label: 'L 2070',
      percentage: parsedTspAllocation.tspL2070 ?? '',
      selected: parsedTspAllocation.tspL2070 != '' ? true : false,

      color: '#344767',
    },
    tspL2075: {
      label: 'L 2075',
      percentage: parsedTspAllocation.tspL2075 ?? '',
      selected: parsedTspAllocation.tspL2075 != '' ? true : false,

      color: '#344767',
    },
  }

  const [tspAllocation, setTspAllocation] = useState(initialAllocation)
  const [tspTotalMixPercent, setTSPTotalMixPercent] = useState(0)

  useEffect(() => {
    const totalPercentage = Object.values(tspAllocation).reduce(
      (sum, data) => sum + (parseFloat(data.percentage) || 0),
      0
    )

    setTSPTotalMixPercent(totalPercentage)
  }, [tspAllocation])

  const handleChange = (key) => (event) => {
    setTspAllocation((prev) => {
      const updatedAllocation = {
        ...prev,
        [key]: { ...prev[key], percentage: parseFloat(event) || 0 },
      }

      // Automatically submit after state update
      const parsedData = Object.fromEntries(
        Object.entries(updatedAllocation).map(([key, data]) => [
          key,
          parseFloat(data.percentage) || 0,
        ])
      )

      updateIntakeStateAndSubmit(() =>
        updateIntakeStateAtKey({ tspAllocation: JSON.stringify(parsedData) })
      )()

      return updatedAllocation
    })
  }

  return (
    <Grid container rowSpacing={1} columnSpacing={3} mb={1}>
      {Object.entries(tspAllocation).map(([key, data]) => (
        <>
          <Grid item xs={6} md={4} mt={1}>
            {renderMuiFormField({
              label: data.label,
              autoFocus: false,
              id: key,
              placeholder: '',
              inputType: 'percentage',
              value: data.percentage,
              onChange: handleChange(key),
            })}
          </Grid>
        </>
      ))}

      <Grid item xs={12}>
        <Box>
          <Box
            mt={2}
            display={'flex'}
            flexDirection={'row'}
            textAlign={'center'}
            alignItems={'center'}
          >
            <Typography textAlign={'center'} variant="h4">
              TOTAL:
            </Typography>
            <Typography
              textAlign={'center'}
              variant="h3"
              pl={1}
              color={
                tspTotalMixPercent.toFixed(2) != 100 ? '#FF0000' : '#262627'
              }
            >
              {tspTotalMixPercent.toFixed(2)}%
            </Typography>
            <Typography variant="body1" ml={0}>
              ({Math.abs(100 - tspTotalMixPercent).toFixed(2)}% off)
            </Typography>
          </Box>

          <Typography variant="body2">
            (Ensure this is 100% before continuing)
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default ClientTSPAllocation
